import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[primaryButton]',
    standalone: false,
})
export class PrimaryButtonDirective {
    @HostBinding('class') elementClass = 'primary-button';
}
